import type { GetSessionResponse } from '../api.types';

type SiteBriefMessage = Pick<GetSessionResponse['session']['messages'][number], 'content' | 'site_brief_choice' | 'site_brief_survey'>;

// Keep historical questions readable after their interactive widget is no longer the latest reply.
export function getSiteBriefMessageText(message: SiteBriefMessage): string {
  const questions = message.site_brief_survey?.questions ?? (message.site_brief_choice ? [message.site_brief_choice] : []);
  const details = questions.map((question) => [
    message.content.includes(question.question) ? '' : question.question,
    ...question.options.map((option) => `- ${option.title}: ${option.description}${option.caveat ? ` (${option.caveat})` : ''}`),
  ].filter(Boolean).join('\n')).filter(Boolean);
  return [message.content, ...details].filter(Boolean).join('\n\n');
}
